<style lang="scss" src='./Catalogs.scss' scoped ></style>
<template src="./Catalogs.html"></template>
<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GrassType from './components/grassType/GrassType.vue';
import FacilityType from './components/facilityType/FacilityType.vue';
import Activity from './components/activity/Activity.vue';
import Management from './components/management/Management.vue';
import Agent from './components/agent/Agent.vue';
import TreeType from './components/treeType/TreeType.vue';
import SoilType from './components/soilType/SoilType.vue';
import PlantType from './components/plantType/PlantType.vue';
import Shrub from './components/shrub/Shrub.vue';
import { mapState, mapMutations, } from 'vuex';

export default {
  name: 'Catalogs',
  extends: SecurityComponent,
  components: {
    GrassType,
    FacilityType,
    Activity,
    Management,
    Agent,
    TreeType,
    SoilType,
    PlantType,
    Shrub,
  },
  data() {
    return {
      tabs: this.getTabs(),
    };
  },
  computed: {
    ...mapState('Catalogs', ['currentTab']),
  },
  methods: {
    ...mapMutations('Catalogs', ['setCurrentTab']),
  },
  created(){
    if(this.$route.query.tab){
      this.setCurrentTab(this.$route.query.tab);
    } else {
      this.setCurrentTab('GrassType');
    }
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Catalogs");
      this.$analytics.logEvent("web_catalogs");
    }
  },

};
</script>
